import { render } from "./BountySummary.vue?vue&type=template&id=09bcfaac&scoped=true&ts=true"
import script from "./BountySummary.vue?vue&type=script&lang=ts"
export * from "./BountySummary.vue?vue&type=script&lang=ts"

import "./BountySummary.vue?vue&type=style&index=0&id=09bcfaac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09bcfaac"]])

export default __exports__